import { useTheme } from '@mui/material';
import type { Theme } from '@mui/system';

import TicketIconFilled from './svg/ticketIconFilledMono.svg';
import TicketIconOutlined from './svg/ticketIconOutlineMono.svg';

export enum ETicketIconVariants {
	Primary = 'PRIMARY',
	PrimaryStroked = 'PRIMARY_STROKED',
	PrimaryVariation = 'PRIMARY_VARIATION',
	Secondary = 'SECONDARY',
}

export interface ITicketIconProps {
	variant?: ETicketIconVariants;
	size?: number;
}

const getSingleColor = (variant: ETicketIconVariants, theme: Theme): string => {
	switch (variant) {
		case ETicketIconVariants.PrimaryVariation:
			return theme.palette.solutions[600];
		case ETicketIconVariants.PrimaryStroked:
			return theme.palette.primary.main;
		case ETicketIconVariants.Secondary:
			return theme.palette.neutral.main;
		case ETicketIconVariants.Primary:
		default:
			return theme.palette.primary.main;
	}
};

export const TicketIcon = ({
	variant = ETicketIconVariants.Primary,
	size = 24,
}: ITicketIconProps) => {
	const theme = useTheme();
	const color = getSingleColor(variant, theme);

	if (variant === ETicketIconVariants.Primary) {
		return (
			<TicketIconFilled
				width={size}
				height={size}
				style={{ display: 'block' }}
				fill={color}
			/>
		);
	}

	return (
		<TicketIconOutlined
			width={size}
			height={size}
			style={{ display: 'block' }}
			fill={color}
		/>
	);
};
